import {useEffect, useRef, useState} from "react";
import Credentials from "./Credentials";
import {Toast} from "primereact/toast";
import Dashboard from "./Dashboard";
import {getSessionApiCall, loginApiCall} from "../utils/apiCalls";

function SessionPanel() {
    const [checksSession, setChecksSession] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);

    useEffect(() => {
        if (isLoggedIn) {
            return;
        }

        async function testSessionId() {
            if (isLoggedIn) {
                return
            }

            setChecksSession(true)
            setIsLoading(true);

            try {
                const response = await getSessionApiCall();

                if (response.ok) {
                    setIsLoggedIn(true);
                }
            } finally {
                setIsLoading(false);
                setChecksSession(false)
            }
        }

        testSessionId();
    }, [isLoggedIn]);

    const toast = useRef<Toast>(null);

    const showLoginSuccess = () => {
        toast.current!.show({
            severity: "success",
            summary: "Logged in",
            detail: "You shall pass!",
        });
    };
    const showLoginError = () => {
        toast.current!.show({
            severity: "error",
            summary: "Invalid credentials",
            detail: "You shall not pass!",
            life: 3000,
        });
    };

    function onLoginClick(username: string, password: string): void {
        setIsLoading(true);

        async function fetchLogin() {
            try {
                const response = await loginApiCall(username, password);

                if (response.ok) {
                    setIsLoggedIn(true);
                    showLoginSuccess();
                } else {
                    showLoginError();
                }
            } catch {
                showLoginError();
                return;
            } finally {
                setIsLoading(false);
            }
        }

        fetchLogin();
    }

    async function onLogout() {
        try {
            await fetch(`/api/auth/logout`, {
                method: "POST",
                credentials: "include",
            });
        } finally {
            setIsLoggedIn(false);
        }
    }

    if (checksSession) {
        return <div></div>
    }

    return (
        <div
            style={{
                maxWidth: "800px",
                margin: "0 auto",
                padding: "1rem",
                boxSizing: "border-box",
            }}
        >
            <Toast ref={toast}/>
            {!isLoggedIn && (
                <Credentials isLoading={isLoading} onLoginClick={onLoginClick}/>
            )}
            {isLoggedIn && (
                <Dashboard onLogoutClick={onLogout}/>
            )}
        </div>
    );
}

export default SessionPanel;
